import React from 'react';

import { AnimatePresence } from 'framer-motion';

import { type CommonActionProps } from '@pkg/primitives';

import { SimpleSpinner } from '../../../SimpleSpinner';

import { Action, Label, Wrapper } from './LoadAction.style';

export interface DataTableLoadActionProps {
    id?: CommonActionProps['id'];
    label?: string;
    ariaLabel?: CommonActionProps['ariaLabel'];
    disabled?: CommonActionProps['disabled'];
    loading?: boolean;
    onAction?: CommonActionProps['onAction'];
}

export function LoadAction({
    id,
    label = 'View more',
    ariaLabel = 'Load more results',
    disabled = false,
    loading = false,
    onAction,
}: DataTableLoadActionProps) {
    const contentMarkup = loading ? (
        <SimpleSpinner key="LoadAction-Spinner" />
    ) : (
        <Label key="LoadAction-Label">{label}</Label>
    );

    return (
        <Wrapper>
            <Action id={id} ariaLabel={ariaLabel} disabled={disabled} onAction={loading ? undefined : onAction}>
                <AnimatePresence mode="wait">{contentMarkup}</AnimatePresence>
            </Action>
        </Wrapper>
    );
}
